import React from 'react'

export const ProviderPayments: React.FC = () => {
  return <div />
}
